<template>
    <div class="report-page">
        <!-- 顶部装饰背景 -->
        <div class="report-header-bg">
            <div class="header-circle c1"></div>
            <div class="header-circle c2"></div>
            <div class="header-circle c3"></div>
        </div>

        <!-- 导航栏 -->
        <div class="report-nav">
            <div class="nav-back" @click="goBack">
                <div class="back-btn-circle">
                    <span class="back-icon">‹</span>
                </div>
            </div>
            <div class="nav-title-wrap">
                <span class="nav-title">咨询总结</span>
                <div class="nav-title-line"></div>
            </div>
            <div class="nav-placeholder"></div>
        </div>

        <!-- 加载状态 -->
        <div class="report-loading" v-if="loading">
            <div class="loading-animation">
                <div
                    class="loading-dot"
                    v-for="i in 3"
                    :key="i"
                    :style="{ animationDelay: i * 0.15 + 's' }"
                ></div>
            </div>
            <span class="loading-text">暖暖老师正在为你生成报告...</span>
        </div>

        <!-- 报告内容 -->
        <div class="report-scroll" v-else-if="reportContent">
            <div class="report-card">
                <!-- 卡片头部 -->
                <div class="card-header">
                    <div class="card-badge">📋</div>
                    <div class="card-title-wrap">
                        <span class="card-title">心理咨询总结报告</span>
                        <span class="card-date">{{ reportDate }}</span>
                    </div>
                </div>
                <!-- 分割线 -->
                <div class="card-divider">
                    <div class="divider-line"></div>
                    <div class="divider-dot"></div>
                    <div class="divider-line"></div>
                </div>
                <!-- 报告正文 -->
                <div class="card-body">
                    <span class="report-text">{{ reportContent }}</span>
                </div>
                <!-- 卡片底部 -->
                <div class="card-footer">
                    <div class="footer-line"></div>
                    <span class="footer-text">由暖暖老师 AI 生成 · 仅供参考</span>
                </div>
            </div>

            <!-- 底部返回按钮 -->
            <div class="report-bottom">
                <div class="back-home-btn" @click="goBack">
                    <span class="back-home-text">返回首页</span>
                </div>
            </div>
        </div>

        <!-- 生成失败 -->
        <div class="report-error" v-else-if="errorMsg">
            <span class="error-icon">😞</span>
            <span class="error-title">报告生成失败</span>
            <span class="error-desc">{{ errorMsg }}</span>
            <div class="retry-btn" @click="generateReport">
                <span class="retry-text">重新生成</span>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from '@/utils/request.js';

export default {
    data() {
        return {
            conversationId: '', // 会话ID
            loading: true, // 是否加载中
            reportContent: '', // 报告内容
            reportDate: '', // 报告日期
            errorMsg: '', // 错误信息
        };
    },
    created() {
        // 从路由 query 中获取会话ID（对应 uniapp 的 onLoad(options)）
        this.conversationId = this.$route.query.conversationId || '';
        this.reportDate = this.formatDate(new Date());
        if (this.conversationId) {
            this.generateReport();
        } else {
            this.loading = false;
            this.errorMsg = '缺少会话信息';
        }
    },
    methods: {
        // 调用后端生成报告
        async generateReport() {
            this.loading = true;
            this.errorMsg = '';
            this.reportContent = '';
            try {
                const res = await request({
                    url: '/api/generate-report',
                    method: 'POST',
                    data: { conversationId: this.conversationId },
                });
                if (res.data.code === 200) {
                    this.reportContent = res.data.data.content || '';
                    if (!this.reportContent) {
                        this.errorMsg = '报告内容为空';
                    }
                } else {
                    this.errorMsg = res.data.message || '生成失败';
                }
            } catch (e) {
                console.error('生成报告失败:', e);
                this.errorMsg = '网络异常，请重试';
            } finally {
                this.loading = false;
            }
        },

        // 返回上一页或首页
        goBack() {
            // 有历史记录则返回上一页，否则跳转聊天首页（对应 uniapp 页面栈判断）
            if (window.history.length > 1) {
                this.$router.back();
            } else {
                this.$router.replace('/chat');
            }
        },

        // 格式化日期
        formatDate(date) {
            const y = date.getFullYear();
            const m = String(date.getMonth() + 1).padStart(2, '0');
            const d = String(date.getDate()).padStart(2, '0');
            const h = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            return `${y}-${m}-${d} ${h}:${min}`;
        },
    },
};
</script>

<style lang="scss" scoped>
.report-page {
    min-height: 100vh;
    background: linear-gradient(180deg, #fff5ee 0%, #fef6f0 40%, #f8f4f2 100%);
    position: relative;
    overflow: hidden;
}

// 顶部装饰圆
.report-header-bg {
    position: absolute;
    top: -60rpx;
    right: -40rpx;
    z-index: 0;
}
.header-circle {
    position: absolute;
    border-radius: 50%;
    opacity: 0.15;
    &.c1 {
        width: 240rpx;
        height: 240rpx;
        background: #e8735a;
        top: 0;
        right: 0;
    }
    &.c2 {
        width: 160rpx;
        height: 160rpx;
        background: #f4a261;
        top: 120rpx;
        right: -60rpx;
    }
    &.c3 {
        width: 100rpx;
        height: 100rpx;
        background: #c0513f;
        top: 40rpx;
        right: 100rpx;
    }
}

// 导航栏
.report-nav {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 80rpx 32rpx 24rpx;
}

// 返回按钮
.nav-back {
    width: 120rpx;
    display: flex;
    align-items: center;
    cursor: pointer;
    &:active {
        opacity: 0.7;
    }
}
.back-btn-circle {
    width: 72rpx;
    height: 72rpx;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4rpx 16rpx rgba(0, 0, 0, 0.08);
    border: 1rpx solid rgba(192, 81, 63, 0.1);
    transition: all 0.2s ease;
    &:active {
        transform: scale(0.92);
        background: rgba(255, 255, 255, 1);
    }
}
.back-icon {
    font-size: 70rpx;
    color: #5a3a3a;
    font-weight: 300;
    line-height: 1;
    position: relative;
    top: -6rpx;
    left: -4rpx;
}

// 标题区域
.nav-title-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.nav-title {
    font-size: 36rpx;
    font-weight: 700;
    color: #3d2c2c;
    letter-spacing: 4rpx;
}
.nav-title-line {
    width: 48rpx;
    height: 4rpx;
    background: linear-gradient(90deg, transparent, #e8735a, transparent);
    border-radius: 2rpx;
    margin-top: 8rpx;
}
.nav-placeholder {
    width: 120rpx;
}

// 加载状态
.report-loading {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 200rpx;
}
// 加载动画（gap 改为相邻 margin，兼容旧浏览器）
.loading-animation {
    display: flex;
    margin-bottom: 32rpx;
}
.loading-dot {
    width: 20rpx;
    height: 20rpx;
    border-radius: 50%;
    background: linear-gradient(135deg, #e8735a, #f4a261);
    animation: dotBounce 1.2s ease-in-out infinite;
}
.loading-dot + .loading-dot {
    margin-left: 16rpx;
}
@keyframes dotBounce {
    0%,
    80%,
    100% {
        transform: scale(0.6);
        opacity: 0.4;
    }
    40% {
        transform: scale(1);
        opacity: 1;
    }
}
.loading-text {
    font-size: 28rpx;
    color: #a08070;
}

// 报告滚动区（scroll-view 改为普通 div 滚动）
.report-scroll {
    position: relative;
    z-index: 1;
    height: calc(100vh - 140rpx);
    padding: 20rpx 32rpx 40rpx;
    box-sizing: border-box;
    overflow-y: auto;
}

// 报告卡片
.report-card {
    background: #fff;
    border-radius: 24rpx;
    padding: 40rpx 36rpx;
    box-shadow: 0 8rpx 32rpx rgba(0, 0, 0, 0.06);
    border: 1rpx solid rgba(192, 81, 63, 0.06);
}
.card-header {
    display: flex;
    align-items: center;
    margin-bottom: 24rpx;
}
.card-badge {
    font-size: 48rpx;
    margin-right: 20rpx;
}
.card-title-wrap {
    display: flex;
    flex-direction: column;
}
.card-title {
    font-size: 32rpx;
    font-weight: 700;
    color: #3d2c2c;
}
.card-date {
    font-size: 22rpx;
    color: #b0a098;
    margin-top: 6rpx;
}

// 分割线（装饰性，gap 改为相邻 margin）
.card-divider {
    display: flex;
    align-items: center;
    margin-bottom: 28rpx;
}
.divider-line + .divider-dot,
.divider-dot + .divider-line {
    margin-left: 16rpx;
}
.divider-line {
    flex: 1;
    height: 1rpx;
    background: linear-gradient(90deg, transparent, rgba(192, 81, 63, 0.2), transparent);
}
.divider-dot {
    width: 10rpx;
    height: 10rpx;
    border-radius: 50%;
    background: #e8735a;
    opacity: 0.5;
}

// 报告正文
.card-body {
    margin-bottom: 28rpx;
}
.report-text {
    font-size: 28rpx;
    color: #4a3a3a;
    line-height: 2;
    white-space: pre-wrap;
    word-break: break-word;
}

// 卡片底部
.card-footer {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.footer-line {
    width: 80rpx;
    height: 1rpx;
    background: rgba(0, 0, 0, 0.08);
    margin-bottom: 16rpx;
}
.footer-text {
    font-size: 22rpx;
    color: #c0b0a8;
}

// 底部按钮（内部单个子元素，原 gap 直接删除）
.report-bottom {
    display: flex;
    justify-content: center;
    padding: 40rpx 0 60rpx;
}
.back-home-btn {
    padding: 24rpx 72rpx;
    border-radius: 44rpx;
    background: linear-gradient(135deg, #e8735a 0%, #c0513f 100%);
    box-shadow: 0 8rpx 28rpx rgba(232, 115, 90, 0.35), 0 2rpx 8rpx rgba(192, 81, 63, 0.2);
    display: flex;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease;
    &:active {
        transform: translateY(2rpx);
        box-shadow: 0 4rpx 16rpx rgba(232, 115, 90, 0.25);
    }
}
.back-home-text {
    font-size: 30rpx;
    color: #fff;
    font-weight: 600;
    letter-spacing: 2rpx;
}

// 错误状态
.report-error {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 200rpx;
}
.error-icon {
    font-size: 80rpx;
    margin-bottom: 24rpx;
}
.error-title {
    font-size: 32rpx;
    font-weight: 600;
    color: #3d2c2c;
    margin-bottom: 12rpx;
}
.error-desc {
    font-size: 26rpx;
    color: #a08070;
    margin-bottom: 40rpx;
}
.retry-btn {
    padding: 18rpx 56rpx;
    border-radius: 32rpx;
    background: rgba(232, 115, 90, 0.1);
    border: 1rpx solid rgba(232, 115, 90, 0.3);
    cursor: pointer;
    &:active {
        opacity: 0.7;
    }
}
.retry-text {
    font-size: 28rpx;
    color: #c0513f;
    font-weight: 600;
}
</style>
